export const TRACKING_API_KEY = '28d6b0e51285579aea8da0600bfedaef';

export const TRACKING_DOMAINS = {
  DATADOG_LOGS: 'logs.browser-intake-datadoghq.eu',
  ANALYTICS: 'analytics.smarfac.com',
  TRACKING: 'amplitude.com',
} as const;

export const TRACKING_DOMAINS_LIST: string[] = Object.values(TRACKING_DOMAINS);

export const TRACKING_ENDPOINTS = {
  TRACKING_SERVER_URL: 'https://analytics.smarfac.com/2/httpapi',
} as const;

export const INTERNAL_DOMAINS = ['@smartfactory.nl', '@smarfac.com'];

export { TRACKING_EVENTS } from './events';
export type { TrackingEventName } from './events';
export type { TrackingEventMap } from './types';

export const OPEN_DEDUPE_MS = 3000;
